import { Action, createAction } from 'redux-act';

import CompanyRegistrationData from '../../../models/form/CompanyRegistrationData';
import TimestampPayload from '../TimestampPayload';

export interface RegisterCompanyPayload {
  companyRegistrationData: CompanyRegistrationData;
}
export const registerCompany = createAction<RegisterCompanyPayload>('REGISTER_COMPANY');
export type RegisterCompanyActionType = Action<RegisterCompanyPayload>;

export interface RegisterResultPayload extends TimestampPayload {
  uuid: string;
}
export const registrationCompleted = createAction<RegisterResultPayload>('REGISTRATION_COMPLETED');
export const registrationFailed = createAction<RegisterResultPayload>('REGISTRATION_FAILED');
